export const environment = {
  production: true,
  dxtBasePath: '/app',
};
